import dynamic from 'next/dynamic'

const COMPLETE_CONFIGURATION = {
  slug: 'done',
  Component: dynamic(() => import('./index')),
  progressBarColor: 'transparent',
  excludeFromprogressBarCount: true,

  // eslint-disable-next-line
  onEnter: async self => {
  },
  // eslint-disable-next-line
  onExit: async self => {
    return true // to allow continue
  }
}

export default COMPLETE_CONFIGURATION
